import { useEffect } from "react"
import { loadScript } from "../utils/loadScripts"
import Footer from "./Footer"
import Header from "./Header"

export default function PrivacyPolicy() {

    useEffect(() => {
        const init = async () => {
            await loadScript("/assets/js/plugins/jquery.min.js")
            await loadScript("/assets/js/plugins/swup.min.js")
            await loadScript("/assets/js/plugins/swiper.min.js")
            await loadScript("/assets/js/plugins/fancybox.min.js")
            await loadScript("/assets/js/plugins/gsap.min.js")
            await loadScript("/assets/js/plugins/smooth-scroll.js")
            await loadScript("/assets/js/plugins/ScrollTrigger.min.js")
            await loadScript("/assets/js/plugins/ScrollTo.min.js")

            await loadScript("assets/js/main.js")
        }

        init()

    }, [])
    return (
        <>

            <div id="swup">

                <Header />

                <div className="mil-content">
                    <div id="swupMain" className="mil-main-transition">

                        <div className="mil-inner-banner">
                            <div className="mil-banner-content mil-center mil-up">
                                <div className="container">
                                    <ul className="mil-breadcrumbs mil-center mil-mb-60">
                                        <li><a href="/">Homepage</a></li>
                                        <li><a href="/blog">Blog</a></li>
                                        <li><a href="/blog">Publication</a></li>
                                    </ul>
                                    <h2>Privacy<span className="mil-thin"> Policy</span></h2>
                                </div>
                            </div>
                        </div>

                        <section id="blog">
                            <div className="container mil-p-120-90">
                                <div className="row justify-content-center">
                                    {/* <!-- <div className="col-lg-12 mil-mb-90">
                                <div className="mil-image-frame mil-horizontal mil-up">
                                    <img src="img/blog/3.jpg" alt="Publication cover" className="mil-scale" data-value-1=".90" data-value-2="1.15"/>
                                </div>
                            </div> --> */}
                                    <div className="col-lg-8">

                                        <p className="mil-text-xl mil-dark mil-up mil-mb-60"><strong>black&white</strong> (“we”, “our”, “us”) operates this website to provide creative, branding, print, digital, electronic, and marketing services. We value your privacy and are committed to protecting the personal information you share with us. By using our website, you agree to the practices described in this Privacy Policy.</p>

                                        <h5 className="mil-up mil-mb-20">Information We Collect</h5>
                                        <p className="mil-up mil-mb-20"><strong>Personal Information: </strong>Name, Email address, Phone number, Company name and Any additional details you choose to share</p>
                                        <p className="mil-up mil-mb-20"><strong>Usage Data: </strong>We automatically collect IP address, Browser type & version, Pages visited, Time spent on pages, Device information and Cookies and tracking data</p>
                                        <p className="mil-up mil-mb-60"><strong>Cookies & Tracking Technologies: </strong>Cookies help us to improve user experience, Analyze website performance, Personalize content and You can choose to disable cookies through your browser settings.</p>

                                        <h5 className="mil-up mil-mb-20">How We Use Your Information</h5>
                                        <p className="mil-up mil-mb-60"><strong>We use collected data to:</strong> Respond to enquiries and provide services, Improve website functionality and user experience, Send updates or marketing communication (only with your consent), Maintain security and prevent fraud, Analyze website performance and usage, Cookies help us to improve user experience, Analyze website performance & Personalize content and You can choose to disable cookies through your browser settings.</p>

                                        <h5 className="mil-up mil-mb-20">Sharing of Information</h5>
                                        <p className="mil-up mil-mb-20">Black&White does not <strong>sell or trade</strong> your personal information.</p>
                                        <p className="mil-up mil-mb-20">We may share data only with: Trusted third-party service providers (hosting, analytics, email tools), Legal authorities, if required by law & Business partners assisting in service delivery (under confidentiality agreements)</p>
                                        <p className="mil-up mil-mb-60">All third parties are required to protect your data securely.</p>

                                        <h5 className="mil-up mil-mb-20">Data Security</h5>
                                        <p className="mil-up mil-mb-20"><strong>We implement reasonable technical and organizational measures to protect your information from:</strong> Unauthorized access, Loss or misuse & Alteration or disclosure</p>
                                        <p className="mil-up mil-mb-60">However, no online transmission is 100% secure. We strive to protect your data but cannot guarantee absolute security.</p>

                                        <h5 className="mil-up mil-mb-20">Your Rights</h5>
                                        <p className="mil-up mil-mb-20"><strong>Depending on your location, you may request:</strong> Access to your personal data, Correction of inaccurate information, Deletion of your data, Restriction or objection to processing & Withdrawal of consent</p>
                                        <p className="mil-up mil-mb-60">To exercise these rights, please contact us at: <a href="mailto:hello@blacknwhite.agency">hello@blacknwhite.agency</a></p>

                                        <h5 className="mil-up mil-mb-20">Third-Party Links</h5>
                                        <p className="mil-up mil-mb-20">Our website may contain links to external websites.</p>
                                        <p className="mil-up mil-mb-60"><strong>black&white</strong> is not responsible for the privacy practices or content of those websites.</p>

                                        <h5 className="mil-up mil-mb-20">Children’s Privacy</h5>
                                        <p className="mil-up mil-mb-60">Our services are not directed toward individuals under 16. We do not knowingly collect children’s personal information.</p>

                                        <h5 className="mil-up mil-mb-20">Changes to This Privacy Policy</h5>
                                        <p className="mil-up mil-mb-60">We may update this Privacy Policy occasionally. Changes will be posted on this page along with the updated date.</p>

                                        <h5 className="mil-up mil-mb-20">Contact Us</h5>
                                        <p className="mil-up mil-mb-20">For questions, concerns, or privacy-related requests, contact:</p>
                                        <p className="mil-up mil-mb-60">Black&White Creative Services <br />hello@blacknwhite.agency</p>

                                        <p className="mil-up mil-mb-60">Policy created/ updated on: 01<sup>st</sup> January 2026</p>


                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>

                <Footer />

            </div>

        </>
    )
}